import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { fetchSkuAndModalList } from "../../hooks/useSkuModal";
import "./skumodal.scss";
import { Spin } from "antd";
import doneIcon from "../../assets/images/done.jpg";

const SkuModalList = () => {
  const getAllListingSku = () =>
    fetchSkuAndModalList("63ef55f307f3f203c3f143f7");

  const {
    data: skuListing,
    refetch,
    isLoading,
  } = useQuery(["orders", "63ef55f307f3f203c3f143f7"], getAllListingSku);

  useEffect(() => {
    refetch();
  }, []);

  if (isLoading) {
    return (
      <div className="spin-center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="sku_Container">
      <Row gutter={[16, 16]}>
        {skuListing?.data?.map((item, index) => {
          let articleImg = item?.article?.articleImage?.thumbPath?.url;
          return (
            <div className="shooting_details" key={index}>
              <div className="shooting_header">
                <h1>SHOOTING GUIDELINES</h1>
              </div>
              <div className="shooting_content">
                <Col className="article_barcode">
                  <div className="barcode_text">
                    <span>{item.skuName}</span>
                  </div>
                  <div className="card-data-spacing">
                    <div className="model-img">
                      <img src={articleImg} alt="" />
                      {/* // bar code */}
                    </div>{" "}
                    <div className="model-img">
                      <img src={articleImg} alt="" />
                    </div>
                    <div className="styling_comment">
                      <span>Styling comments</span>
                    </div>
                  </div>
                </Col>
                <Col className="shooting_angles">
                  {item?.angles.map((item, index) => {
                    let shootAngleImg = item?.angle?.file?.imagePath?.url;
                    let isShootAccepted = true;
                    return (
                      <div className="angle_content" key={index}>
                        <span className="angle_name">{item.angle.name}</span>
                        <div className="angle_legend">
                          <div className="angle_img">
                            {isShootAccepted && (
                              <div className="row-end">
                                <img
                                  alt=""
                                  src={doneIcon}
                                  style={{
                                    height: "40px",
                                    width: "40px",
                                  }}
                                />
                              </div>
                            )}
                            <div className="model-img">
                              <img src={shootAngleImg} alt="" />
                            </div>
                          </div>
                          <div className="supporting_articles">
                            {item.supportingArticles.map((article) => {
                              let articleImg = article.image?.thumbPath?.url;
                              return (
                                <div className="model-img ">
                                  <img src={articleImg} alt="" />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="styling_legend">
                          <div className="styling_comment">
                            <span>Styling comments</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Col>
              </div>
            </div>
          );
        })}
      </Row>
    </div>
  );
};

export default SkuModalList;
